//路由表
const routes = [
    {
        path: '/',
        component: () => import('@/App.vue'),
        name: 'App',
        children:[
            {
                path: '/',
                component: () => import('@/components/Main-Page.vue'),
                name: 'Main-Page.vue',
                children:[
                    {
                        path: '/',
                        component: () => import('@/components/home/Home-Page'),
                        name: 'Home-Page',
                    },
                    {
                        path: '/Saving-Marriage',
                        component: () => import('@/components/home/Saving-Marriage.vue'),
                        name: 'Saving-Marriage',
                    },
                    {
                        path: '/Dissuade-From-Leaving',
                        component: () => import('@/components/home/Dissuade-From-Leaving.vue'),
                        name: 'Dissuade-From-Leaving',
                    },
                    {
                        path: '/Success-Stories',
                        component: () => import('@/components/home/Success-Stories.vue'),
                        name: 'Success-Stories',
                    },
                    {
                        path: '/Authoritative-Experts',
                        component: () => import('@/components/home/Authoritative-Experts.vue'),
                        name: 'Authoritative-Experts',
                    },
                    {
                        path: '/Media-Coverage',
                        component: () => import('@/components/home/Media-Coverage.vue'),
                        name: 'Media-Coverage',
                    },
                    {
                        path: '/About-Us',
                        component: () => import('@/components/home/About-Us.vue'),
                        name: 'About-Us',
                    },
                ]
            },
        ]
    },
]
export {routes}
